export default __webpack_public_path__ + "static/media/icon-serious-face-empty.6266f162.svg";